import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HTTP_INTERCEPTORS } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { LoginService } from "./login.service";
import { environment } from "environments/environment";

@Injectable()
export class AuthIntercepror implements HttpInterceptor {


  constructor(private loginService: LoginService) {

  }

//   intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//        let authReq = req;
//        const token = this.loginService.getToken();
//        if (token != null) {
//         authReq = authReq.clone({
//             setHeaders: {Authorization: `Bearer ${token}`}
//         })
//        }
//        return next.handle(authReq);
//    }
intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let authReq = req;

    // Obtén el token predeterminado
    const defaultToken = this.loginService.getToken();

    // Verifica si la URL contiene la palabra "facebook"
    if (req.url.includes('facebook')) {
      // Si la URL contiene "facebook", usa un token diferente
      const facebookToken = environment.whatsappToken;
      authReq = req.clone({
        setHeaders: { Authorization: `Bearer ${facebookToken}` }
      });
    } else if (defaultToken != null) {
      // Si no, usa el token predeterminado
      authReq = req.clone({
        setHeaders: { Authorization: `Bearer ${defaultToken}` }
      });
    }

    return next.handle(authReq);
  }
}

export const AuthInterceprorProviders = [
    {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthIntercepror,
        multi: true
    }
   ]

